import React, { Component } from 'react';
import { connect } from "react-redux";

import { Row, Col } from 'reactstrap';

import * as actions from '../../actions/ApiActions';

import NumberedItem from '../../components/NumberedItem/NumberedItem'
import Headline from '../../components/Headline/Headline'
import Section from '../../components/Section/Section'
import Button from "../../components/Button/Button";
import Content from "../../components/Content/Content";
import ContactForm from '../../components/ContactForm/ContactForm';
import PricingCards from '../../components/PricingCards/PricingCards';
import PricingTable from '../../components/PricingTable/PricingTable';

class PricingContainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <Section pattern header>
          <Headline pageTitle>
            Was passt am besten zu Ihnen?
          </Headline>
          <Headline center subtitle>Profitieren Sie von den Quickdoctor Startpartner Paketen.</Headline>
        </Section>
        <div>

          <Section triangle ref={this.doctorRef} grey>
            <Row>
              <Col lg={{ size: 12 }} xs={12}>

                <PricingCards />
                {/*<PricingTable />*/}

              </Col>
            </Row>
          </Section>
        </div>
      </div>
    )
  }
}

export default connect(null, actions)(PricingContainer);



// WEBPACK FOOTER //
// ./src/container/public/PricingContainer.js